const table101 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "row_number",
        name: "行番号",
        editable: false
    },
    {
        key: "begin_earnings_reserve",
        name: "期首利益積立金額",
        editable: true
    }
];

export { table101 };
